export default "__VITE_ASSET__B6v9v0x5__"